import React, { useContext, useEffect, useRef, useState } from 'react'
import { getSessionToken } from '@futures-platform/connectors/session'
import { fetcher } from '../../helpers/fetcher'
import { isEmpty } from '../../helpers/utils'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import styles from './YoutubeImageEmbed.module.css'

//generic embed for any content type, consider putting into a library
const YoutubeImageEmbed = ({ content, isReviewMode }) => {
  const publicURL = process.env.REACT_APP_MEDIA_API_URL
  const {
    state: {
      groupRadarIdGlobalState,
      langForTransState,
      getTheWholeCardHtmlElms,
      isTranslated,
    },
    dispatch,
  } = useContext(DataContext)
  const cardMediaTextRef = useRef()
  const cardMediaTextRef2 = useRef()

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(null)

  useEffect(() => {
    const fetcherData = async () => {
      const res1 =
        (!!cardMediaTextRef2.current || originalTitle) &&
        (await fetcher.translation(
          'en',
          langForTransState,
          originalTitle ?? cardMediaTextRef2.current,
        ))
      settranslations(() => {
        return {
          res1,
        }
      })
    }
    !!isTranslated && !!originalTitle && fetcherData()
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (
      content?.media?.text ||
      content?.media?.videoText ||
      content?.videoText
    ) {
      if (true) {
        if (
          !cardMediaTextRef2?.current &&
          !!cardMediaTextRef.current?.innerHTML
        ) {
          cardMediaTextRef2.current = cardMediaTextRef.current?.innerHTML
        }
        !!cardMediaTextRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardMediaTextRef2.current)
        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD10,
        //   payload: true
        // })
      }
    }
  }, [dispatch, isTranslated, originalTitle, content])
  const isEmbedRadar =
    !!window && !!window.location && !!window.location.ancestorOrigins?.length
      ? true
      : false

  return content && !isEmpty(content) ? (
    <>
      {content?.media?.video && (
        <div className={styles.videoIframeWrapper}>
          <iframe
            className={styles.iframeForVideo}
            width="853"
            height="480"
            src={content?.media?.video}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
        </div>
      )}
      {!!content?.image && (
        <img
          className={styles.mediaImage}
          // src={
          //   !isEmbedRadar
          //     ? publicURL + content?.image
          //     : publicURL +
          //       content?.image +
          //       `?access_token=${getSessionToken()}`
          // }
          src={
            !isEmbedRadar
              ? content?.image
              : content?.image + `?access_token=${getSessionToken()}`
          }
          alt="nature"
          loading="lazy"
        />
      )}

      {!isTranslated &&
      (content?.media?.text ||
        content?.media?.videoText ||
        content?.videoText) ? (
        <p className={styles.mediaText} ref={cardMediaTextRef}>
          {!!isReviewMode
            ? !!content?.videoText || content?.videoText === ''
              ? content?.videoText
              : content?.media?.text || content?.media?.videoText
            : content?.videoText ||
              content?.media?.text ||
              content?.media?.videoText}
        </p>
      ) : (
        <p
          className={styles.mediaText}
          dangerouslySetInnerHTML={{ __html: translations?.res1?.data }}></p>
      )}
    </>
  ) : null
}
export default YoutubeImageEmbed
